// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28759":"01183b73","74326":"cf19db87","93406":"6b451de3"}[chunkId] + ".chunk.css";
};